<template>
  <div class="fun-footer">
    <span v-for="(data,index) in datas" :key="index" @click="clickthing(data.name)" :class="judgeColor(data)">
      <img :src="judge(data)"  alt />
      {{ data.name}}
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        {
          name: "点赞",
          noimg: require("@/assets/public/dq-zan@2x.png"),
          img: require("@/assets/public/dq-zan1@2x.png")
        },
        {
          name: "收藏",
          noimg: require("@/assets/public/dq-shoucang@2x.png"),
          img: require("@/assets/public/dq-shoucang1@2x.png")
        }
      ]
    };
  },
  props: {
    id: Number | String,
    dbnum: Number | String , 
    zan : Boolean,
    collect : Boolean,
    headline: String
  },
  methods: {
    judge(data){      
      if(data.name==='点赞'){
        return this.zan?data.img:data.noimg
      }else{
        return this.collect?data.img:data.noimg
      }
      
    },
    judgeColor(data){
      if(data.name==='点赞'){
        return this.zan?'span-red':''
      }else{
        return this.collect?'span-red':''
      }
    },
    clickthing(name){
      if (name === '点赞') {
        this.praise()
      }else{
        this.Addcollect()
      }
   
    },
    praise(){
      this.axios.post(
        '/api/Main/GetPoint',
        {
          rid:this.dbnum,
          loginname:sessionStorage.getItem('token'),
          pmbid:this.id,
          status: this.zan?1:0
        }
      ).then(e=>{
        if(e.data.code==0){
          this.$emit('zan',!this.zan)
        }
        
      })
    },
    Addcollect(){
      this.axios.post(
        '/api/Main/addCollct',
        {
          token: sessionStorage.getItem('token'),
          loginname: this.headline,
          town:location.href,
          status:this.collect?1:0
        }
      ).then(e=>{
        if(e.data.code==0){
          this.$emit('collect',!this.collect)
        }
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.fun-footer {
  .span-red{
    color: red;
  }
  span {
    &:not(last-child) {
      border-right: 0.01rem solid #eeeeee;
    }
    img {
      width: 0.28rem;
      height: 0.28rem;
    }
  }
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
  background: #fff;
  text-align: center;
  line-height: 3;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));
  border-top: .01rem solid #eeeeee;
}
</style>